<template>
  <div id="">
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item v-for="item in yearOptions">
          <el-button class="el-form-button" type="primary" v-on:click="onChangeYear(item.value)">{{item.label}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.year" placeholder="年份"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.title" placeholder="标题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.playStatus" placeholder="播放状态" @change="loadData">
            <el-option v-for="item in playStatusOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="el-form-button" type="primary" v-on:click="loadData">查询</el-button>
          <el-button class="el-form-button" type="success" v-show="canPull" v-on:click="pullData">拉取</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <el-table
      :data="tableData"
      style="width: 100%"
      row-key="id"
      border
      lazy
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="audioDate" label="节目日期" width="100"></el-table-column>
      <el-table-column prop="loveqTitle" label="节目标题" width="300"></el-table-column>
      <el-table-column label="播放状态" width="100">
        <template slot-scope="scope">
          {{scope.row.playStatusName}} {{scope.row.progressDesc}}
        </template>
      </el-table-column>
      <!--第二步  开始进行修改和查询操作-->
      <el-table-column label="" align="center" min-width="100">
        <template slot-scope="scope">
          <el-button :type="getButtonType(scope.row.playStatus)" @click="play(scope.row.id)">播放</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页组件-->
    <PageGroup v-bind:pageInfo="pageInfo" @pageChange="loadData"></PageGroup>

  </div>
</template>

<script>
import {loveqApi} from '../../api/index';
import {HttpResp} from '../../constant/index';
import PageGroup from "../template/PageGroup";

export default {
  name: 'LoveqList',
  components: {PageGroup},
  data() {
    return {
      playStatusOptions: [{
        value: '',
        label: '全部播放状态'
      }, {
        value: '1',
        label: '未开始'
      }, {
        value: '2',
        label: '播放中'
      }, {
        value: '3',
        label: '已完成'
      }, {
        value: '4',
        label: '未完成'
      }],
      yearOptions: [{
        value: '2023',
        label: '2023'
      }, {
        value: '2018',
        label: '2018'
      }],
      tableData: [],
      addFormReadOnly: true,
      dialogVisible: false,
      isView: true,
      modifyTag: false,
      addFormData: {
        id: '',
        level: '',
        parentId: '',
        name: '',
        url: '',
        permissionCode: '',
        style: ''
      },

      filters: {
        year: '',
        playStatus: '4',
        title: ''
      },

      pageInfo: {
        pageNumber: 1, //默认在第一页
        pageSize: 10, //默认每页显示1条数据
        total: 1, //默认总条数为一条
      },

      defaultProps: {
        children: 'children',
        label: 'label'
      },
      canPull: false,
    }
  },
  mounted: function () {
    // 添加当日所在年份到列表
    const currentYear = new Date().getFullYear();
    this.yearOptions.unshift({
      value: currentYear,
      label: currentYear
    });
    // 加载数据
    this.loadData();
  },
  computed: {

  },
  methods: {
    loadData() {
      let param = {
        pageNumber: this.pageInfo.pageNumber,
        pageSize: this.pageInfo.pageSize,
        year: this.filters.year,
        playStatus: this.filters.playStatus,
        title: this.filters.title
      };
      loveqApi.pageWithProgress(param).then(data => {
        if(data.code == HttpResp.SUCCUSS){
          this.tableData = data.data.dataList;
          this.pageInfo.total = data.data.total;
          if (data.data.total == 0) {
            // 分页没有数据则查询全年是否有数据
            this.countByYear(this.filters.year);
          } else {
            // 隐藏拉取按钮
            this.canPull = false;
          }
        }else{
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
    // 查询全年是否有数据
    countByYear(year) {
      let param = {
        year: year
      }
      loveqApi.countByYear(param).then(data => {
        if(data.code === HttpResp.SUCCUSS){
          // 全年都没有数据，则显示拉取按钮
          this.canPull = data.data === 0;
        }else{
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
    // 摘取数据
    pullData() {
      // 隐藏拉取按钮
      this.canPull = false;
      let param = {
        year: this.filters.year
      }
      loveqApi.pull(param).then(data => {
        if(data.code === HttpResp.SUCCUSS){
          this.loadData();
        }else{
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
    getButtonType(playStatus) {
      if (playStatus == 1) {
        // 未开始
        return "success";
      } else if (playStatus == 2) {
        // 播放中
        return "primary";
      } else if (playStatus == 3) {
        // 已完成
        return "warning";
      }
    },
    play(audioId) {
      //带参数跳转
      this.$router.push({path:'/loveq/detail',query:{audioId:audioId}});
    },
    onChangeYear(year) {
      // 切换年份
      this.filters.year = year;
      this.loadData();
    },

  }

}
</script>



// WEBPACK FOOTER //
// src/components/loveq/LoveqList.vue